// Get API base URL from runtime configuration or environment variables
const getApiBaseUrl = () => {
  // Try to get from runtime config first (for production)
  if (window.ENV && window.ENV.REACT_APP_API_BASE_URL && window.ENV.REACT_APP_API_BASE_URL !== 'REACT_APP_API_BASE_URL_PLACEHOLDER') {
    return window.ENV.REACT_APP_API_BASE_URL;
  }
  // Fallback to build-time environment variable (for development)
  return process.env.REACT_APP_API_BASE_URL || 'REACT_APP_API_BASE_URL_PLACEHOLDER';
};

const API_BASE_URL = getApiBaseUrl();
export const apiService = {
  // Get Primary Recruiter
  async getPrimaryRecruiter(organizationId) {
    const url = `${API_BASE_URL}/hiring-manager/primary-hiring-manager?organization_id=${organizationId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    const data = await response.json();
    return data;
  },

  async savePrimaryRecruiter(recruiterData) {
    const payload = {
      name: recruiterData.name.trim(),
      email: recruiterData.email.trim(),
      organization_id: recruiterData.organizationId,
      is_primary: true,
      is_active: true,
      department: "string"
    };

    console.log('Sending primary recruiter payload:', payload);

    const response = await fetch(`${API_BASE_URL}/hiring-manager/create-hiring-manager`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    return await response.json();
  },

  // Save Hiring Managers - Updated to send array to backend
  async saveHiringManagers(hiringManagersArray) {
    console.log('Sending hiring managers payload:', hiringManagersArray);

    const response = await fetch(`${API_BASE_URL}/recruiter/add-recruiter-emails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(hiringManagersArray)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    return await response.json();
  },

  // Fetch all hiring managers for an organization
  async getHiringManagers(organizationId) {
    console.log('Fetching hiring managers for organization:', organizationId);

    const response = await fetch(`${API_BASE_URL}/recruiter/get-recruiter-emails?organization_id=${organizationId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    return await response.json();
  },

  // Delete a hiring manager
  async deleteHiringManager(hiringManagerEmail, organizationId) {
    console.log('Deleting hiring manager:', hiringManagerEmail, 'for organization:', organizationId);

    const payload = {
      emails: [hiringManagerEmail],
      organization_id: organizationId
    };

    console.log('Sending delete hiring manager payload:', payload);

    const response = await fetch(`${API_BASE_URL}/recruiter/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    return await response.json();
  },

  // Bulk delete hiring managers
  async bulkDeleteHiringManagers(emailsArray, organizationId) {
    console.log('Bulk deleting hiring managers:', emailsArray, 'for organization:', organizationId);

    const payload = {
      emails: emailsArray,
      organization_id: organizationId
    };

    console.log('Sending bulk delete hiring managers payload:', payload);

    const response = await fetch(`${API_BASE_URL}/recruiter/delete-recruiter-emails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || response.statusText);
    }

    return await response.json();
  }
};
